import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(''),
  routes: [
    {
      path: '/',
      name: 'slots',
      component: () => import('../views/ChallengeView.vue'),
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('../views/InviteView.vue'),
      props: (route) => ({ msg: route.query.msg }),
    },
    {
      path: '/challenge',
      name: 'challenge',
      component: () => import('../views/ShowcaseView.vue'),
      props: (route) => ({ code: route.query.c }),
    },
    {
      path: '/create-challenge',
      name: 'create-challenge',
      component: () => import('../views/ChallengeCreatorView.vue'),
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('../views/RulesView.vue'),
    },
    {
      path: '/igdb',
      name: 'igdb',
      component: () => import('../views/IgdbSearchView.vue'),
    },
    {
      path: '/games',
      name: 'game-list',
      component: () => import('../views/GameListView.vue'),
    },
    {
      path: '/games/:id(\\d+)',
      name: 'game-detail',
      component: () => import('../views/GameDetailView.vue'),
      props: (route) => ({ id: Number(route.params.id) }),
    },
    {
      path: '/ui-sandbox',
      name: 'ui-sandbox',
      component: () => import('../views/UISandboxView.vue'),
    },
  ],
});

export default router;
